export enum UnconfirmedDocumentType {
  Document = 'document',
  TreatmentPlan = 'treatment_plan'
}
